import { GET_API } from "../../Functionalities/APIs";

export const ManageWallet = async (data, keyword, params, path) => {
  // void 0
  if (keyword == "get") {

    if (params != "") {
      
      let result = GET_API("", params, path);
      return await result.then((result) => {
        if (result) {
          return result;
        } else {
          return 0;
        }
      });
    } else {
      let result = GET_API("", params, path);
      return await result.then((result) => {
        if (result) {
          return result;
        } else {
          return 0;
        }
      });
    }
  }
};